module.exports = __webpack_public_path__ + "assets/img/face_attribute_describe.614c37de.png";